import { getPullRequestNumberAsString } from "./getPullRequestNumberAsString";

export const getPullRequestNumber = (
  fullBranchName?: string
): string | undefined => {
  // full pull request name is in the format "refs/pull/#xx/merge"
  return getPullRequestNumberAsString(fullBranchName);
};
